import React, { useState } from 'react';
import { Bot, Loader2 } from 'lucide-react';
import useAIChat from './ai-assistant/useAIChat';
import {
  SessionList, ModeSelector, ChatHeader, WelcomeScreen,
  MessageList, ChatInput,
} from './ai-assistant/AIComponents';

/**
 * AIAssistant — Orchestrates the AI Tuning Copilot chat interface.
 * Split from original 395-line monolith into:
 *   - ai-assistant/useAIChat.js (state + API hook)
 *   - ai-assistant/AIComponents.jsx (UI sub-components)
 */
export default function AIAssistant({ vehicle }) {
  const chat = useAIChat(vehicle);
  const [showSidebar, setShowSidebar] = useState(false);

  const handleSelectSession = (sid) => {
    chat.loadHistory(sid);
    setShowSidebar(false);
  };

  const handleNewChat = () => {
    chat.handleNewChat();
    setShowSidebar(false);
  };

  const handleQuickPrompt = (prompt) => {
    chat.setInput(prompt);
    chat.inputRef.current?.focus();
  };

  return (
    <div className="flex h-[700px] bg-[#050505] border border-[#27272A] rounded-sm overflow-hidden" data-testid="ai-assistant">
      {/* Sidebar */}
      <div className={`${showSidebar ? 'block' : 'hidden'} md:block w-64 flex-shrink-0 bg-[#0A0A0A] border-r border-[#27272A] p-4 overflow-y-auto`}>
        <div className="flex items-center gap-2 mb-4">
          <Bot className="w-4 h-4 text-[#FF5E1A]" />
          <span className="text-sm font-bold text-white font-['Outfit']">Chat History</span>
          {chat.loadingSessions && <Loader2 className="w-3 h-3 text-zinc-600 animate-spin ml-auto" />}
        </div>
        <SessionList sessions={chat.sessions} activeSessionId={chat.sessionId} onSelect={handleSelectSession} onNew={handleNewChat} />
      </div>

      {/* Main Chat Area */}
      <div className="flex-1 flex flex-col min-w-0">
        <ChatHeader vehicle={vehicle} showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
        <ModeSelector mode={chat.mode} setMode={chat.setMode} />

        <div className="flex-1 overflow-y-auto px-4 py-4">
          {chat.messages.length === 0 ? (
            <WelcomeScreen vehicle={vehicle} onQuickPrompt={handleQuickPrompt} />
          ) : (
            <MessageList messages={chat.messages} sending={chat.sending} messagesEndRef={chat.messagesEndRef} />
          )}
        </div>

        <ChatInput
          input={chat.input} setInput={chat.setInput} mode={chat.mode}
          sending={chat.sending} onSend={chat.sendMessage} inputRef={chat.inputRef}
        />
      </div>
    </div>
  );
}
